import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box'
import { Typography, Grid, Card, CardContent, Chip } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MDButton from 'components/MDButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import { BorderColorRounded, DoneAllRounded, GetAppRounded, DescriptionRounded, CheckCircle, Warning, Error, Info } from '@mui/icons-material';
import ConsultaMatriculas from './consultamatricula';
import EntregaMatriculas from './entregamatricula';
import Recepciondocumentos from './recepciondocumentos';
import DevolverMatricula from './devolvermatricula';
import EstadoMatriculas from './estadomatriculas';
import { useApi, useSucursales } from "lib/api";

var drawerWidth = 350;

function Transferenciasdocumentos(props) {
  const { post } = useApi();
  const [programa,setPrograma] = useState('');
  const [desplegarmenu,setDesplegarmenu] = useState(false);
  const [programacargado,setProgramacargado] = useState(false)
  
  const[fecha1,setFecha1] = useState("")
  const[fecha2,setFecha2] = useState("")
  const[nosucursal,setNosucursal] = useState("")
  const[rows,setRows] = useState([])
  const[rowsOriginal,setRowsOriginal] = useState([])
  const[solochasis,setsolochasis] = useState([])
  const sucursales = useSucursales()
  const[sucursalesTrans,setSucursalesTrans] = useState([])

  const[currentsucursal,setCurrentSucursal] = useState(localStorage.getItem("sucursal"))
  const[transferidos,setTransferidos] = useState([])
  const[estatuspago,setEstatuspago] = useState("No Cobrado")
  const[open,setOpen] = useState(false)
  const[noprest,setNoprest] = useState(0)
  const[chasis,setChasis] = useState("")
  const[position, setPosition] = useState(0)
  const[sucursalTrans, setSucursalTrans] = useState('')
  const[tipoDocumento, setTipoDocumento] = useState('')
  const[tiposSeleccionados, setTiposSeleccionados] = useState([])
  const[transportista, setTransportista] = useState('Transportista')
  const[comentario, setComentario] = useState('')
  const[chasisSeleccionado, setChasisSeleccionado] = useState('')
  const[chasisDisponibles, setChasisDisponibles] = useState([])
  // Estados para el diálogo de notificaciones
  const[dialogOpen, setDialogOpen] = useState(false)
  const[dialogTitle, setDialogTitle] = useState('')
  const[dialogMessage, setDialogMessage] = useState('')
  const[dialogType, setDialogType] = useState('info') // 'info', 'success', 'warning', 'error'
  const[botondesactivado,setBotondesactivado] = useState(false)

  // Opciones de tipos de documentos
  const [tiposDocumentos, setTiposDocumentos] = useState([
    { value: 'placa', label: 'Placa', estado: true,entregado:false },
    { value: 'matricula', label: 'Matricula', estado: true,entregado:false },
  ]);

  const handledesplegarmenu = () => {
    setDesplegarmenu(!desplegarmenu);
  };

  // Función para mostrar diálogo de notificación
  const showDialog = (title, message, type = 'info') => {
    setDialogTitle(title);
    setDialogMessage(message);
    setDialogType(type);
    setDialogOpen(true);
  };

  // Función para cerrar el diálogo
  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  const[documentosTransito, setDocumentosTransito] = useState([])



  // Función para cargar chasis disponibles
  const cargarChasisDisponibles = async () => {
    const { status, data } = await post('/api/consultarmatricula', {
      'sucursal': currentsucursal
    })
    if (status === 200) {
      setChasisDisponibles(data["matriculas2"] || []);
    }
    if (status === 400) {
      showDialog('Error de Conexión', data["Error"], 'error');
    }
  };

  const drawerWidth = 240

  // Cargar chasis disponibles cuando se monta el componente
  useEffect(() => {
    cargarChasisDisponibles();
  }, [currentsucursal]);

  // Inicializar valores cuando cambie la pantalla (position)
  useEffect(() => {
    // Resetear todos los valores cuando cambie la posición
    setChasisSeleccionado('')
    setTiposSeleccionados([])
    setSucursalTrans('')
    setTransportista('Transportista')
    setComentario('')
    setTransferidos([])
    setDocumentosTransito([])
    cargarChasisDisponibles()
    // Resetear tipos de documentos a estado inicial
    setTiposDocumentos([
      { value: 'placa', label: 'Placa', estado: true,entregado:true },
      { value: 'matricula', label: 'Matricula', estado: true,entregado:true },
    ])
  }, [position]);

  
  
  const columns = [
  {
    field: 'Marca',
    headerName: 'Marca',
    type: 'string',
    width: 100,
  },
  {
    field: 'Modelo',
    headerName: 'Modelo',
    type: 'string',
    width: 100,
  },
  {
    field: 'Color',
    headerName: 'Color',
    type: 'string',
    width: 100,
  },
  {
    field: 'Chasis',
    headerName: 'Chasis',
    type: 'string',
    width: 210,
  },
  {
    field: 'Valor',
    headerName: 'Valor',
    type: 'string',
    width: 100,
  },
  
  {
    field: ' ',
    width: 150,
    renderCell:(params)=>{
      return(
        <MDButton variant="gradient" color="info" onClick={()=>agregartransferidos(params.row)}  fullWidth>seleccionar</MDButton>
      );
    }
  },
  
];


function agregartransferidos(row){
  const newItems = rows.filter(item => item !== row);
  setRows(newItems);
  setRowsOriginal(rowsOriginal.filter(item => item !== row))
  
  setTransferidos([...transferidos,row])

}

function eliminarTransferido(row){
  const newItems = transferidos.filter(item => item !== row);
  setTransferidos(newItems);

  setRows([...rows,row])
  setRowsOriginal([...rows,row])

}

// Funciones simplificadas para transferencia de documentos
function limpiarTransferencia(){
  setTransferidos([])
  setSucursalTrans('')
  setTipoDocumento('')
  setTiposSeleccionados([])
  setTransportista('Transportista')
  setComentario('')
  setChasisSeleccionado('')
}

 async function confirm(sucursalTrans,transportista,comentario,tipoDocumento){
  
  // Validar que se hayan seleccionado tipos de documentos
  if (tiposSeleccionados.length === 0) {
    showDialog('Validación Requerida', 'Debe seleccionar al menos un tipo de documento', 'warning');
    setBotondesactivado(false)
    return;
  }

  // Validar que se haya seleccionado un chasis
  if (!chasisSeleccionado) {
    showDialog('Validación Requerida', 'Debe seleccionar un chasis para la transferencia', 'warning');
    setBotondesactivado(false)
    return;
  }

  // Crear resumen de tipos seleccionados
  const tiposResumen = tiposSeleccionados.map(tipo => 
    tiposDocumentos.find(t => t.value === tipo)?.label
  ).join(', ');

  const documentos = {
    'sucursalrecep':sucursalTrans.label,
    'documentos': tiposSeleccionados.join(','),
    'entregado':false,
  }
  
  const documentosjson = tiposSeleccionados.map( item => (
    
    {
      'sucursalrecep':sucursalTrans.label,
      'documento':item,
      'entregado':false
    }

  ))

  
  const { status, data } = await post('/api/transferenciabackend_creartransferenciadocumentos', {
    'tipo':'documentos',
    'sucursal': currentsucursal,
    "sucursalrecep":sucursalTrans.label,
    "sucursalusuario":localStorage.getItem("sucursalmatricula"),
    "motores":transferidos,
    "comentario":comentario=="comentario"?'':comentario,
    "transportista":transportista=="transportista"?'':transportista,
    "tiposDocumentos":tiposSeleccionados, // Enviar array de tipos seleccionados
    "tipoDocumento":"Documento", // Indicar que es una transferencia mixta
    "chasisSeleccionado":chasisSeleccionado, // Chasis seleccionado para la transferencia
    "documentosjson":documentosjson
  })
  if (status === 200) {
        // Generar PDF con resumen de tipos seleccionados
        //PlantillaTransferencia(sucursalTrans,localStorage.getItem("nombrenegocio"),transferidos,`Documentos transferidos - ${tiposResumen}`)

        // Limpiar la transferencia después de completarla
        
        console.log("manueljr3",tiposSeleccionados)
        console.log("manueljr4",tiposDocumentos)
        
        {/*actualizar front-end con los documentos enviados */}
        let tiposdocumentos = [...tiposDocumentos]
        
        tiposSeleccionados.map(seleccionados => {
          tiposdocumentos = tiposdocumentos.map(item => {
            if (seleccionados == item.value) {
              return {...item, estado: true, enviado: true}
            } else {
              return item
            }
          })
        })
        console.log("manueljr5",tiposdocumentos)
        setTiposDocumentos(tiposdocumentos)
        
        showDialog('Transferencia Exitosa', `Transferencia de documentos completada exitosamente. Tipos: ${tiposResumen}`, 'success');
        setBotondesactivado(false)
        limpiarTransferencia()
        setBotondesactivado(false)
  }
  if (status === 400) {
      showDialog('Error en Transferencia', data["Error"], 'error');
      setBotondesactivado(false)
  }


}



function closeTransfer(){
  setTransferidos([])
}

const handleClose = () => {
  setOpen(false);
};

function alertar(cellValues){
  showDialog('Información', cellValues, 'info');
}

// Componente de diálogo personalizado
const CustomDialog = () => {
  const getIcon = () => {
    switch(dialogType) {
      case 'success':
        return <CheckCircle style={{color: '#4caf50', fontSize: 48}} />;
      case 'warning':
        return <Warning style={{color: '#ff9800', fontSize: 48}} />;
      case 'error':
        return <Error style={{color: '#f44336', fontSize: 48}} />;
      default:
        return <Info style={{color: '#2196f3', fontSize: 48}} />;
    }
  };

  const getColor = () => {
    switch(dialogType) {
      case 'success':
        return '#4caf50';
      case 'warning':
        return '#ff9800';
      case 'error':
        return '#f44336';
      default:
        return '#2196f3';
    }
  };

  
  
  return (
    <Dialog
      open={dialogOpen}
      onClose={handleDialogClose}
      aria-labelledby="custom-dialog-title"
      aria-describedby="custom-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="custom-dialog-title" style={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        color: getColor()
      }}>
        {getIcon()}
        {dialogTitle}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="custom-dialog-description" style={{fontSize: '16px', lineHeight: '1.5'}}>
          {dialogMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{padding: '16px 24px'}}>
        <Button 
          onClick={handleDialogClose} 
          variant="contained"
          style={{
            backgroundColor: getColor(),
            color: 'white',
            minWidth: '100px'
          }}
          autoFocus
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

function seleccionarChasis(event, newValue) {
  setChasisSeleccionado(newValue?.chasis || '')
 
  let aerror = false
  if (aerror === false) {
    if (newValue && newValue.inventario !== 'S') {
    showDialog('Error', 'El chasis no ha sido  recibido', 'error');
    aerror = true
    return;
  }

  if (aerror === false) {
    if (newValue && newValue.sucursalmatriculaentregada) {
      
      if (newValue.sucursalmatriculaentregada !== '-1' ) {
        
          if(newValue.sucursaldocumentos.length > 0) {   
          const documentosEnviados = JSON.parse(newValue.sucursaldocumentos).documentos.split('*')
          // Actualizar el estado de los tipos de documentos
          console.log('Tipos de documentos:', documentosEnviados)
          Cargardocumentostransito(newValue.chasis,newValue.sucursaldocumentos)
          
        }
      } else {
        if (newValue) {
          Cargardocumentostransito(newValue.chasis,newValue.sucursaldocumentos)
        } 
      }
    } else {
      if (newValue) {
        Cargardocumentostransito(newValue.chasis,newValue.sucursaldocumentos)
      }
    }
  }
}}

async function Cargardocumentostransito(chasis,sucursaldocumentos) {
  const { status, data } = await post('/api/transferenciabackend_cargardocumentostransito', {
    'chasis':chasis
  })
  if (status === 200) {
      setBotondesactivado(true)

        if (data["documentostransito"].length > 0) {
          const nuevosTiposDocumentos = tiposDocumentos.map(tipo => { 
            
            const yaEnviado = data["documentostransito"].some(doc => doc['documento'].includes(tipo.value))
            return {
              ...tipo,
              estado: yaEnviado
            }
          })
          setTiposDocumentos(nuevosTiposDocumentos)
          setTiposSeleccionados([])
        } else {
          {/*logica para validar los documentos recibiddos*/}
          let sucursaldocumentostienedatos = 0
          if (sucursaldocumentos) {
              sucursaldocumentostienedatos = 1
          } else {
            sucursaldocumentostienedatos = 0
          }
          
          if (sucursaldocumentostienedatos == 1) {
            const existeasterisco = JSON.parse(sucursaldocumentos).documentos.includes('*')
            
            if (existeasterisco) {
              {/*hay varios documentos*/}
              const documentos = JSON.parse(sucursaldocumentos).documentos.split('*')
              let nuevosTiposDocumentos = [...tiposDocumentos]

              documentos.map(item => {  
                // Modificar nuevosTiposDocumentos basándose en la condición
                nuevosTiposDocumentos = nuevosTiposDocumentos.map(tipo => {
                  console.log("manuel11",tipo.value,item.documento)
                  if (tipo.value === JSON.parse(item).documento) {
                    console.log("manuel10",tipo.value,item.documento)
                    return {
                      ...tipo,
                      estado: true,
                    } 
                  } else { 
                    console.log("manuel12",tipo)
                    return {...tipo, estado: false};
                  }
                })
              })
            } else {
              {/*solo hay un documento*/}
              const documentos = [JSON.parse(sucursaldocumentos).documentos]
              console.log("manuel13",documentos)
              // Crear nuevosTiposDocumentos una sola vez
              let nuevosTiposDocumentos = [...tiposDocumentos];
              console.log("manuel7",nuevosTiposDocumentos)
              documentos.map(item => {
                
                // Modificar nuevosTiposDocumentos basándose en la condición
                nuevosTiposDocumentos = nuevosTiposDocumentos.map(tipo => {
                  console.log("manuel11",tipo.value,item)
                  if (tipo.value === JSON.parse(item).documento) {
                    console.log("manuel10",tipo.value,item)
                    return {
                      ...tipo,
                      estado: true,
                    } 
                  } else { 
                    console.log("manuel12",tipo)
                    return {...tipo, estado: false};
                  }
                })
              })
              
              setTiposDocumentos(nuevosTiposDocumentos)
              console.log("manuel8",nuevosTiposDocumentos)
              
            }  
          } else {
          
              const nuevosTiposDocumentos = tiposDocumentos.map(tipo => { 
              return {
                ...tipo,
                estado: false
              }})
              setTiposDocumentos(nuevosTiposDocumentos)
      
          } 
            
          setTiposSeleccionados([])
        }
        setBotondesactivado(false)

  }


}


  const sections = [
    { id: 0, title: "Revision", icon: DoneAllRounded },
    { id: 1, title: "Creacion", icon: BorderColorRounded },
    { id: 2, title: "Recepcion", icon: GetAppRounded },
    { id: 3, title: "Devoluciones", icon: GetAppRounded },
    { id: 4, title: "Seguimiento", icon: DescriptionRounded },
    { id: 5, title: "Entrega", icon: DescriptionRounded },
  ];

  return(
     <Box component="main" sx={{ p: 3, backgroundColor: "#f8fbff", minHeight: "100vh" }}>
      <Card elevation={3} sx={{ mb: 3, borderRadius: 2 }}>
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
            <Box>
              <Typography variant="h4" component="h1" fontWeight="bold" color="primary">
                Transferencia de Documentos
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.6 }}>
                Gestione revision, creacion, recepcion, devoluciones y seguimiento de documentos.
              </Typography>
            </Box>
            <Chip
              label={`Sucursal actual: ${currentsucursal || "-"}`}
              sx={{
                fontWeight: 700,
                color: "#1363DF",
                bgcolor: "#EAF3FF",
                border: "1px solid #D7E3F7",
              }}
            />
          </Box>
        </CardContent>
      </Card>

      <Card elevation={2} sx={{ mb: 3, borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom sx={{ mb: 2, fontWeight: 600 }}>
            Secciones
          </Typography>
          <Grid container spacing={2}>
            {sections.map((section) => {
              const IconComp = section.icon;
              const isActive = position === section.id;
              return (
                <Grid item xs={12} sm={6} md={4} lg={2} key={section.id}>
                  <Box
                    onClick={() => setPosition(section.id)}
                    sx={{
                      cursor: "pointer",
                      p: 2,
                      borderRadius: 2,
                      textAlign: "center",
                      border: "1px solid",
                      borderColor: isActive ? "#1363DF" : "#E2E8F0",
                      bgcolor: isActive ? "#1363DF" : "#FFFFFF",
                      color: isActive ? "#FFFFFF" : "#334155",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        transform: "translateY(-1px)",
                        boxShadow: 2,
                        borderColor: "#98C0FF",
                      },
                    }}
                  >
                    <IconComp sx={{ fontSize: 30, mb: 0.5 }} />
                    <Typography sx={{ fontWeight: 700, fontSize: "0.95rem" }}>{section.title}</Typography>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </CardContent>
      </Card>

        {position==0?
          <Box sx={{ mt: 1 }}>
            <ConsultaMatriculas></ConsultaMatriculas>
          </Box>
        :''}

        {position==1?
        <Box>
        <Grid container spacing={3} sx={{ mt: 0.5 }}>
          <Grid item xs={12} md={6}>
            <Card elevation={2} sx={{ borderRadius: 2, height: "100%" }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                  Informacion de Transferencia
                </Typography>
                <Box sx={{ mb: 2, p: 2, bgcolor: "#EAF3FF", borderRadius: 2, border: "1px solid #D7E3F7" }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, mb: 0.5 }}>
                    Sucursal de Origen
                  </Typography>
                  <Typography variant="h6" sx={{ color: "#0E3768", fontWeight: 700 }}>
                    {currentsucursal || "Sucursal Actual"}
                  </Typography>
                </Box>
                <Box sx={{ p: 2, bgcolor: "#F8FAFC", borderRadius: 2, border: "1px solid #E2E8F0" }}>
                  <Typography variant="body2" sx={{ mb: 0.7 }}>Fecha: {new Date().toLocaleDateString()}</Typography>
                  <Typography variant="body2" sx={{ mb: 0.7 }}>Hora: {new Date().toLocaleTimeString()}</Typography>
                  <Typography variant="body2">Usuario: {localStorage.getItem('usuario') || 'Usuario actual'}</Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card elevation={2} sx={{ borderRadius: 2, height: "100%" }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                  Configurar Transferencia
                </Typography>
                <Box sx={{ mb: 2 }}>
              <Autocomplete
                disablePortal
                id="sucursal-selector"
                options={sucursales}
                value={sucursalTrans}
                onChange={(event, newValue) => setSucursalTrans(newValue)}
                renderInput={(params) => 
                  <TextField {...params} 
                    variant="outlined"
                    label="Sucursal de destino" 
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    sx={{ '& .MuiOutlinedInput-root': { minHeight: '45px' } }}
                  />}
              />
                </Box>

            <Box sx={{ mb: 2 }}>
              <Autocomplete
                disablePortal
                id="chasis-selector"
                options={chasisDisponibles}
                getOptionLabel={(option) => option.chasis || ''}
                value={chasisDisponibles.find(ch => ch.chasis === chasisSeleccionado) || null}
                onChange={seleccionarChasis}
                renderInput={(params) => 
                  <TextField {...params} 
                    variant="outlined"
                    label="Chasis  *" 
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    sx={{ '& .MuiOutlinedInput-root': { minHeight: '45px' } }}
                  />}
              />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Box sx={{display:"flex", justifyContent:"space-between", alignItems:"center", mb: 1.2}}>
                <Typography variant="subtitle1" sx={{fontWeight: 700}}>
                  Tipos de Documentos a Transferir *
                </Typography>
                <Box sx={{display:"flex", gap:1}}>
                  <MDButton 
                    variant="gradient" 
                    color="info" 
                    size="small"
                    onClick={() => {
                      const tiposDisponibles = tiposDocumentos
                        .filter(tipo => !tipo.estado)
                        .map(tipo => tipo.value);
                      setTiposSeleccionados(tiposDisponibles);
                    }}
                    disabled={tiposDocumentos.every(tipo => tipo.estado)}
                  >
                    Disponibles
                  </MDButton>
                  <MDButton 
                    variant="gradient" 
                    color="warning" 
                    size="small"
                    onClick={() => setTiposSeleccionados([])}
                  >
                    Ninguno
                  </MDButton>
                </Box>
              </Box>
              <Box sx={{ border: "1px solid #E2E8F0", borderRadius: 2, p: 1.2, minHeight: "120px", bgcolor: "#F8FAFC" }}>
                {tiposDocumentos.map((tipo) => {
                  const isChecked = tiposSeleccionados.includes(tipo.value)
                  const isDisabled = tipo.estado // Deshabilitado si ya fue enviado
                  
                  return (
                    <Box key={tipo.value} sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 1,
                      opacity: isDisabled ? 0.5 : 1
                    }}>
                      <input
                        type="checkbox"
                        id={`tipo-${tipo.value}`}
                        checked={isChecked}
                        disabled={isDisabled}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setTiposSeleccionados([...tiposSeleccionados, tipo.value]);
                          } else {
                            setTiposSeleccionados(tiposSeleccionados.filter(t => t !== tipo.value));
                          }
                        }}
                        style={{
                          marginRight: "8px",
                          cursor: isDisabled ? "not-allowed" : "pointer"
                        }}
                      />
                      <label 
                        htmlFor={`tipo-${tipo.value}`} 
                        style={{
                          cursor: isDisabled ? "not-allowed" : "pointer", 
                          fontSize:"14px",
                          color: isDisabled ? "#999" : "#000"
                        }}
                      >
                        {tipo.label}
                        {isDisabled && (
                          <span style={{fontSize:"12px", color:"#999", marginLeft:"5px"}}>
                            (Ya enviado)
                          </span>
                        )}
                      </label>
                    </Box>
                  )
                })}
              </Box>
              {tiposDocumentos.some(tipo => tipo.estado) && (
                <Typography variant="body2" sx={{mt:1, color:"#B45309"}}>
                  Documentos ya enviados: {tiposDocumentos
                    .filter(tipo => tipo.estado)
                    .map(tipo => tipo.label)
                    .join(', ')}
                </Typography>
              )}
              {tiposSeleccionados.length > 0 && (
                <Typography variant="body2" sx={{mt:1, color:"#475569"}}>
                  Seleccionados: {tiposSeleccionados.map(tipo => 
                    tiposDocumentos.find(t => t.value === tipo)?.label
                  ).join(', ')}
                </Typography>
              )}
            </Box>

            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                label="Transportista"
                value={transportista}
                onChange={(event) => setTransportista(event.target.value)}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                sx={{ '& .MuiOutlinedInput-root': { minHeight: '45px' } }}
              />
            </Box>

            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                label="Comentarios"
                value={comentario}
                onChange={(event) => setComentario(event.target.value)}
                variant="outlined"
                multiline
                rows={3}
                InputLabelProps={{ shrink: true }}
              />
            </Box>

            <Box sx={{display:"flex", gap:1.2}}>
              <MDButton 
                variant="gradient" 
                color="success" 
                disabled={botondesactivado}
                onClick={()=>{
                  
                  if(localStorage.getItem("sucursalmatricula") !== currentsucursal.split("-")[0]) {
                    showDialog('Validación Requerida', 'Usted no pertenece a la sucursal princial', 'warning');
                    return;
                  }
                  setBotondesactivado(true)
                  if(sucursalTrans === '') {
                    showDialog('Validación Requerida', 'Debe seleccionar una sucursal de destino', 'warning');
                    setBotondesactivado(false)
                    return;
                  }
                  if(!chasisSeleccionado) {
                    showDialog('Validación Requerida', 'Debe seleccionar un chasis de destino', 'warning');
                    setBotondesactivado(false)
                    return;
                  }
                  if(tiposSeleccionados.length === 0) {
                    showDialog('Validación Requerida', 'Debe seleccionar al menos un tipo de documento', 'warning');
                    setBotondesactivado(false)
                    return;
                  }
                  confirm(sucursalTrans, transportista, comentario, tipoDocumento);
                }}
                style={{flex:1, minHeight: "44px"}}
              >
                Transferir Documentos
              </MDButton>
              
              <MDButton 
                variant="gradient" 
                color="warning" 
                onClick={limpiarTransferencia}
                style={{flex:1, minHeight: "44px"}}
              >
                Limpiar
              </MDButton>
            </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>      
        </Box>
        :''}     
        {position==2?
          <Box sx={{ mt: 1 }}>
            <Recepciondocumentos tipo={"documentos"}></Recepciondocumentos>
          </Box>
        :''}     
        
        {position==3?
          <Box sx={{ mt: 1 }}>
            <DevolverMatricula></DevolverMatricula>
          </Box>
        :''}
        
        {position==4?
          <Box sx={{ mt: 1 }}>
            <EstadoMatriculas></EstadoMatriculas>
          </Box>
        :''}
        {position==5?
          <Box sx={{ mt: 1 }}>
            <EntregaMatriculas></EntregaMatriculas>
          </Box>
        :''}

     {/*ventana de dialogo*/}
     <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style = {{width:"100%", height:"500px"}}
 
      >
        <DialogTitle id="alert-dialog-title">
          {"Eliminacion Registro"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
                Desea Eliminar este registro de Incauto?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button style = {{color: "white"}} onClick={handleClose} autoFocus>
            NO
          </Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo personalizado para notificaciones */}
      <CustomDialog />

      </Box> 

    );    
}
export default Transferenciasdocumentos
